import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const TipoCambioService = {
    getActual: async () => {
        const response = await getAxios().get('/api/tipo-cambio/actual');
        return response.data;
    },
    getByEmpresa: async (empresaId) => {
        const response = await getAxios().get(`/api/tipo-cambio/empresa/${empresaId}`);
        return response.data;
    },
    syncTiposCambio: async (empresaId) => {
        const response = await getAxios().post(`/api/tipo-cambio/empresa/${empresaId}/actualizar`);
        return response.data;
    },
    updateConfig: async (empresaId, codigoIso, payload) => {
        const response = await getAxios().put(`/api/tipo-cambio/empresa/${empresaId}/moneda/${codigoIso}/config`, payload);
        return response.data;
    },
    toggleEstado: async (empresaId, codigoIso, isActivo) => {
        const response = await getAxios().put(`/api/tipo-cambio/empresa/${empresaId}/moneda/${codigoIso}/estado`, { activa: isActivo });
        return response.data;
    }
};
